import React from 'react';

type PrintReportShellProps = {
  pageSize: string;
  toolsPanel: React.ReactNode;
  children: React.ReactNode;
  watermarkText?: string;
  printFooter?: React.ReactNode;
};

const PrintReportShell: React.FC<PrintReportShellProps> = ({
  pageSize,
  toolsPanel,
  children,
  watermarkText,
  printFooter,
}) => {
  return (
    <div className="min-h-screen bg-slate-600 print:min-h-0" dir="rtl">
      <style>{`
        @media print {
          @page { size: ${pageSize}; margin: 8mm; }
          .print\\:hidden { display: none !important; }
          html, body, #root {
            height: auto !important;
            min-height: 0 !important;
            overflow: visible !important;
            background: #fff !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          .print-watermark {
            position: fixed;
            inset: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            pointer-events: none;
            z-index: 2;
          }
          .print-footer {
            position: fixed;
            bottom: 4mm;
            left: 0;
            right: 0;
            text-align: center;
            z-index: 3;
          }
        }
      `}</style>

      <div className="print:hidden sticky top-0 z-50 border-b-4 border-sky-600 bg-white p-4 shadow-md">
        {toolsPanel}
      </div>

      <div className="mx-auto my-6 max-w-[297mm] rounded-sm bg-white p-4 shadow-2xl print:m-0 print:max-w-full print:rounded-none print:p-0 print:shadow-none">
        {watermarkText ? (
          <div className="print-watermark hidden print:flex">
            <div className="rotate-[-22deg] text-[26px] font-bold text-slate-300/55">{watermarkText}</div>
          </div>
        ) : null}
        {children}
        {printFooter ? <div className="print-footer hidden print:block">{printFooter}</div> : null}
      </div>
    </div>
  );
};

export default PrintReportShell;
